import { gql } from "@apollo/client"

export const GET_DATA = gql`
  query getData($data: ViewQueryInput!) {
    views {
      getData(data: $data) {
        rows {
          data {
            name
            value
          }
        }
        totalCount
      }
    }
  }
`

export const GET_DEFINITION = gql`
  query getDefinition($data: ViewDefinitionInput!) {
    views {
      getDefinition(data: $data) {
        filters {
          name
          type
        }
        defaultSort {
          name
          direction
        }
        allowedSorts
        defaultFields
        fieldDefinitions {
          name
          type
        }
        convertFields
      }
    }
  }
`

export const CSV_DOWNLOAD = gql`
  query csvDownload($data: ViewDownloadInput!) {
    views {
      csvDownload(data: $data) {
        output
      }
    }
  }
`
